import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'
import { paths } from '../../../links'
import { PaymentMethodListing } from './BankCardListing/PaymentMethodListing'
import AddCreditDebitCard from '../../AddCreditDebitCard'
import LinkBankAccount from './LinkPaymentScreens/LinkBankAccount'
import {
  headerMode,
  screenOptions,
} from '../../../../utils/helpers/commonUtils'

const Stack = createStackNavigator()

export default () => {
  return (
    <Stack.Navigator
      headerMode={headerMode}
      initialRouteName={paths.Console.More.ListMethods}
      mode="modal"
      screenOptions={screenOptions}
    >
      <Stack.Screen
        name={paths.Console.More.ListMethods}
        component={PaymentMethodListing}
      />
      <Stack.Screen name={paths.LinkCard} component={AddCreditDebitCard} />
      <Stack.Screen name={paths.LinkBank} component={LinkBankAccount} />
    </Stack.Navigator>
  )
}
